var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("VDropdown", {
    staticClass: "favorites-folder-select",
    attrs: {
      round: "",
      items: _vm.folders,
      "key-mapper": (f) => f.id,
      value: _vm.folder,
    },
    on: {
      change: function ($event) {
        return _vm.change($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _vm._v(" " + _vm._s(item.name) + " (" + _vm._s(item.count) + ") "),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }